import { useState } from "react";
import {
  Grid,
  Card,
  TextField,
  Divider,
  Button,
  Stack,
  Switch,
  Typography,
} from "@pankod/refine-mui";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import TreatmentsSelector from "./TreatmentsSelector";

function CardPrezziario({
  last = true,
  prezziario,
  setNGuest,
  setBasePrice,
  setChildrenPrice,
  setIsBreakfast,
  setTreatments,
  addNew,
  removeCard,
}) {
  return (
    <Grid item xs={12} md={12} sx={{ height: "100%" }}>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Grid container sx={{ flex: 1, p: 2 }} spacing={2}>
          <Grid item xs={6} md={6} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              label="n occupanti"
              type={"number"}
              value={prezziario.tot_guests}
              onChange={(e) => {
                setNGuest(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={6} md={3} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              label="prezzo base"
              type={"number"}
              value={prezziario.base_price}
              onChange={(e) => {
                setBasePrice(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={6} md={3} sx={{ height: "100%" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              variant={"outlined"}
              fullWidth
              label="prezzo per bambini"
              type={"number"}
              value={prezziario.children_price}
              onChange={(e) => {
                setChildrenPrice(Number(e.target.value));
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} sx={{ height: "100%" }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="subtitle1" color="text.secondary">
                Colazione inclusa
              </Typography>
              <Switch
                checked={prezziario.breakfast_included}
                onChange={(e) => {
                  setIsBreakfast(e.target.checked);
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} sx={{ height: "100%" }}>
            <Typography variant="button" component="div">
              Trattamenti
            </Typography>
          </Grid>
          <TreatmentsSelector
            treatments={prezziario.treatments}
            setTreatments={setTreatments}
            isBreakfast={prezziario.breakfast_included}
          />
        </Grid>
        <Divider orientation="vertical" flexItem />
        <Button
          variant="contained"
          sx={{
            width: 50,
            alignSelf: "normal",
            alignItems: "center",
            bgcolor: "info.main",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
          onClick={() => {
            if (last) {
              addNew();
            } else {
              removeCard();
            }
          }}
        >
          {last ? (
            <AddCircleOutlineOutlinedIcon />
          ) : (
            <RemoveCircleOutlineOutlinedIcon />
          )}
        </Button>
      </Card>
    </Grid>
  );
}

export default CardPrezziario;
